import React from 'react';
import { motion } from 'framer-motion';
import { FaClock, FaExclamationTriangle, FaRedo } from 'react-icons/fa';

const RateLimitError = ({ error, onRetry, retryAfter = 15 }) => {
  const [timeLeft, setTimeLeft] = React.useState(retryAfter * 60); // Convert minutes to seconds

  React.useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed top-4 right-4 z-50 max-w-md"
    >
      <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-lg shadow-lg">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <FaExclamationTriangle className="h-5 w-5 text-red-500" />
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-sm font-medium text-red-800">
              Too Many Requests
            </h3>
            <div className="mt-2 text-sm text-red-700">
              <p>{error?.message || 'You have made too many requests. Please wait before trying again.'}</p>
              
              {timeLeft > 0 && (
                <div className="mt-3 flex items-center text-red-600">
                  <FaClock className="h-4 w-4 mr-2" />
                  <span className="font-medium">
                    Try again in: {formatTime(timeLeft)}
                  </span>
                </div>
              )}
              
              {timeLeft === 0 && onRetry && (
                <button
                  onClick={onRetry}
                  className="mt-3 inline-flex items-center px-3 py-2 border border-red-300 rounded-md text-sm font-medium text-red-700 bg-white hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                >
                  <FaRedo className="h-4 w-4 mr-2" />
                  Try Again
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default RateLimitError;
